import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledFeedbackMessage,
  StyledFeedbackMessageText,
  StyledFeedbackMessageIcon
} from './FeedbackMessage.style';
import { hashString } from '../../libs/stringHashing';

function getIcon(variant) {
  if (variant === 'error') return 'warning';
  if (variant === 'info') return 'info';
  return 'warning';
}

/**
 * With the Feedback Message component you can display feedback to the user.
 * It is a more compact component then the MessageBar, which is used for more prominent messages.
 * This component contains 2 feedback types, error and info.
 * Each type has its own text color and icon.
 */

function FeedbackMessage({
  variant = 'error',
  feedbackTexts,
  dataAttributes = {},
  className = ''
}) {
  return (
    <StyledFeedbackMessage className={className} {...dataAttributes}>
      <StyledFeedbackMessageIcon
        $variant={variant}
        $iconSize="small"
        icon={getIcon(variant)}
      />
      <StyledFeedbackMessageText $variant={variant}>
        {feedbackTexts.map((feedbackText) => (
          <span tw="block" key={hashString(feedbackText)}>
            {feedbackText}
          </span>
        ))}
      </StyledFeedbackMessageText>
    </StyledFeedbackMessage>
  );
}

FeedbackMessage.propTypes = {
  feedbackTexts: PropTypes.arrayOf(PropTypes.string).isRequired,
  /* Will determine icon, text color and icon color of FeedbackMessage */
  variant: PropTypes.oneOf(['error', 'info']),
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string,
  dataAttributes: PropTypes.shape({})
};

export default FeedbackMessage;
